import React, { useState, useEffect, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { fetchGeographies } from "../../redux/actions/GeographyActions";
import EnhancedTable from "../table/Table";
import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import GeographyForm from "./GeographyForm";
import Loader from "../../components/loader/Loader";
import { GeographyModel } from "../../models/GeographyModel";
import { isValidArr } from "../../utility/utils";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  // status: string;
};

const GeographyPage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<GeographyModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allData = useAppSelector((state) => state.geography.all_Geographies);
  const isGeographiesFetching = useAppSelector(
    (state) => state.geography.isGeographiesFetching
  );

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all geographies
  useEffect(() => {
    dispatch(fetchGeographies());
  }, [dispatch]);

  useEffect(() => {
    setRootData(() =>
      allData.map((rec) => ({
        id: rec.geographyId,
        name: rec.name,
        description: rec.description,
        // status: rec.isActive ? "Active" : "Inactive",
      }))
    );
  }, [allData]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editRec = allData.find((rec) => rec.geographyId === id);
    setMode("edit");
    setEditData(editRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allData) && isGeographiesFetching ? <Loader /> : null}
      <PageTitle
        title="Geographies"
        btnText="Add Geography"
        onClick={createHandler}
      />
      <PageSearch
        placeholder="Search Geographies"
        searchHandler={searchHandler}
      />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={mode === "add" ? "Create Geography" : "Edit Geography"}
          handleModalClose={handleModalClose}
        >
          <GeographyForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default GeographyPage;
